export const LANGUAGE_DE = 'de'
export const LANGUAGE_FR = 'fr'
export const LANGUAGE_IT = 'it'
export const LANGUAGE_ES = 'es'
export const LANGUAGE_NL = 'nl'
